import template from "./pPasswordReset.html";

export function pPasswordResetDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pPasswordResetController,
    controllerAs: 'pPasswordReset',
    bindToController: true
  };

  return directive;
}

class pPasswordResetController {
  constructor ($log, $scope, $location, $routeParams, Auth, Bundle) {
    'ngInject';
    this.$location = $location;
    this.$routeParams = $routeParams;
    this.Auth = Auth;
    this.Bundle = Bundle;
    this.newPassword = "";

    if($routeParams.passwordToken) {
      this.state = "set-password-form";
    } else {
      this.state = "send-link-form";
    }
  }

  sendLink() {
    this.state = "sending-link";
    this.Auth.sendPasswordResetLink(this.email).then(() => {
      this.state = "send-link-success";
    }, (error) => {
      this.state = "send-link-error";
      this.error = error;
    });
  }

  setNewPassword() {
    this.state = "setting-password";
    this.Auth.setNewPassword(this.$routeParams.passwordToken, this.newPassword).then(() => {
      this.$location.path("/login");
    }, (error) => {
      this.state = "set-password-error";
      this.error = error;
    });
  }
}
